import {checkRequiredParameters, createOcapiFetch} from './utils'

class OcapiShopperStores {
    constructor(config) {
        this.fetch = createOcapiFetch(config)
    }

    async getStore(...args) {
        const required = ['id']

        let requiredParametersError = checkRequiredParameters(args[0], required)
        if (requiredParametersError) {
            return requiredParametersError
        }
        const {id} = args[0].parameters

        return await this.fetch(`stores/${encodeURIComponent(id)}`, 'GET', args, 'getStore')
    }
}

export default OcapiShopperStores
